<template>
    <card class="card-plain">
        <form v-if="user" v-loading.lock="loading" autocomplete="off">
            <div class="card-body row pt-0">
                <div class="col-12 p-0">
                    <div class="col-md-6">
                        <legend v-if="user._id">{{$t('User Account and User Settings')}}</legend>
                        <fg-input type="text"
                                  :label="$t('Login name')"
                                  required
                                  v-validate="validations.username"
                                  :error="getError('username')"
                                  name="username"
                                  :placeholder="$t('Login name')"
                                  v-model="user.username"
                                  autocomplete="off">
                        </fg-input>
                    </div>
                    <div class="col-md-6">
                        <fg-input v-if="user._id"
                                  type="password"
                                  :label="$t('Password')"
                                  :info="$t('note upper and lower case')"
                                  name="password"
                                  v-validate="validations.passwordOpt"
                                  :error="getError('password')"
                                  autocomplete="off"
                                  v-model="newPassword"
                                  placeholder="***************"
                        />
                    </div>
                </div>
                <div class="col-12"><hr></div>
                <div class="col-12">
                    <div class="row">
                        <div class="col-md-3">
                            <fg-input type="text"
                                      :label="$t('First Name')"
                                      :placeholder="$t('First Name')"
                                      v-model="user.firstName"
                                      autocomplete="off">
                            </fg-input>
                        </div>
                        <div class="col-md-3">
                            <fg-input type="text"
                                      :label="$t('Last Name')"
                                      :placeholder="$t('Last Name')"
                                      v-model="user.lastName"
                                      autocomplete="off">
                            </fg-input>
                        </div>
                        <div class="col-md-6">
                            <fg-input type="email"
                                      required
                                      autocomplete="off"
                                      v-validate="validations.email"
                                      :error="getError('email')"
                                      :label="$t('Email')"
                                      name="email"
                                      :placeholder="$t('Email')"
                                      v-model="user.email">
                            </fg-input>
                        </div>
                    </div>
                </div>
                <div class="col-12 p-0">
                    <div class="col-md-6 form-group">
                        <label>{{ $t('Join Date') }}
                            <el-date-picker v-model="user.joinedAt"
                                            type="date"
                                            :placeholder="$t('Join Date')"
                            >
                            </el-date-picker>
                        </label>
                    </div>
                </div>
                <div class="col-12 p-0 form-group">
                    <div class="col-sm-12 col-md-3">
                        <p-checkbox v-model="user.active">{{ $t('Account Active') }}</p-checkbox>
                    </div>
                    <div class="col-sm-12 col-md-3">
                        <p-checkbox v-if="checkPackage(['premium'])" v-model="user.extern">{{ $t('External User') }}</p-checkbox>
                        <p-checkbox v-else v-model="user.extern" disabled>{{ $t('External User') }}</p-checkbox>
                    </div>
                    <div class="col-sm-12 col-md-3">
                        <p-checkbox v-if="checkPackage(['premium'])" v-model="user.permissions.news_publisher">{{ $t('News Publisher') }}</p-checkbox>
                        <p-checkbox v-else v-model="user.permissions.news_publisher" disabled>{{ $t('News Publisher') }}</p-checkbox>
                    </div>
                </div>
                <div class="col-12 p-0">
                    <div class="col-sm-6">
                        <fg-input :label="$t('Roles')">
                            <el-select multiple class="select-primary"
                                       size="medium"
                                       v-model="user.roles"
                                       :placeholder="$t('Roles')">
                                <el-option v-for="option in roleOptions"
                                           class="select-primary"
                                           :value="option.key"
                                           :label="$t(option.label)"
                                           :key="option.key">
                                </el-option>
                            </el-select>
                        </fg-input>
                    </div>
                    <div class="col-sm-6 form-group" v-if="user._id">
                        <label>{{ $t('Teams') }}</label>
                        <list class="m-0 p-0" v-model="user.teams" :columns="columns" hide-header/>
                    </div>
                </div>
            </div>
            <div class="card-footer text-right actions">
                <p-button round native-type="button" class="btn-wd btn-one-size-dropdown button-distance" :disabled="loading"
                          @click.prevent="cancel">
                    {{ $t('cancel') }}
                </p-button>
                <p-button round native-type="submit" type="primary"
                          class="btn btn-fill btn-wd btn-one-size-dropdown"
                          :disabled="loading"
                          @click.prevent="save">
                    {{ $t('Save') }}
                </p-button>
            </div>
            <div class="clearfix"></div>
        </form>
    </card>
</template>

<script>
  import { DatePicker, Select, Option } from 'element-ui'
  import { UserRecord } from 'src/store/models/User'
  import 'element-ui/packages/theme-chalk/src/input.scss'
  import List from '../../Components/BasicList'
  import get from 'lodash/get'

  export default {
    name: 'UserEdit',
    components: {
      [DatePicker.name]: DatePicker,
      [Option.name]: Option,
      [Select.name]: Select,
      List
    },
    data () {
      return {
        userData: {},
        newPassword: null,
        validations: {
          username: {
            required: true
          },
          email: {
            required: true,
            email: true
          },
          password: {
            required: true,
            min: 5
          },
          passwordOpt: {
            min: 5
          }
        },
        loading: false,
        roleOptions: [
          {key: 'admin', label: 'Admin'},
          {key: 'user', label: 'User'}
        ],
        datePickerOptions: {
          shortcuts: []
        },
        columns: [{ name: 'title', text: 'Title', sortable: true, align: 'left' }]
      }
    },
    computed: {
      userId: function () {
        return this.$route.params.id || ''
      },
      user: function () {
        return this.userData
      }
    },
    watch: {
      async '$route' () {
        await this.initData()
      },
      async '$route.params.id' () {
        await this.initData()
      }
    },
    async mounted () {
      await this.initData()
    },
    methods: {
      async initData () {
        if (this.$route.name === 'UserCreate') {
          this.userData = new UserRecord({ active: true, roles: ['user'], permissions: { news_publisher: false } })
        } else {
          await this.fetchUser()
        }
      },
      async fetchUser () {
        if (!this.userId) {
          return
        }
        try {
          this.loading = true
          const result = await UserRecord.api().get(`/user/${this.userId}`, { save: false })
          this.userData = new UserRecord(result.response.data)
        } catch (e) { console.log('e', e)} finally {
          this.loading = false
        }
      },
      getError (fieldName) {
        return this.$t(this.errors.first(fieldName))
      },
      cancel () {
        this.$router.push({ name: 'UserList' })
      },
      async save () {
        const isValid = await this.$validator.validateAll()
        if (!isValid) {
          return
        }

        const { username, email, firstName, lastName, roles, active, extern, joinedAt, permissions } = this.userData
        const password = this.newPassword || this.userData.password

        const data = { username, email, firstName, lastName, roles, password, active, extern, joinedAt, permissions }

        try {
          this.loading = true

          if (this.userData._id) {
            const result = await UserRecord.api().put(`/user/${this.userId}`, data, { save: false })
            this.userData = new UserRecord(result.response.data)

            this.$notify({ message: this.$t('Successfully saved.'), type: 'success' })

          } else {
            const result = await UserRecord.api().post(`/user`, data, { save: false })
            if (result.response.data._id) {

              this.$notify({ message: this.$t('Successfully saved.'), type: 'success' })

              this.$router.push({ name: 'UserEdit', params: { id: result.response.data._id } })
            }
          }
        } catch (e) {
          let message = e.message
          if (e.response) {
            message = get(JSON.parse(e.response.data.message), '[0].email', e.message)
          }
          this.$notify({ message, type: 'danger' })

        } finally {
          this.loading = false
        }
      },
      checkPackage(allowedPackages) {
        return allowedPackages.includes(this.$auth.user.customer.settings.contract.packageType)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .button-distance {
    margin-right: 10px !important;
  }

  @media (max-width: 590px) {
      .btn-one-size-dropdown {
          width: 100%;
          padding-left: 0px;
          padding-right: 0px;
          padding-right: 10px !important;
      }

      .card-footer {
        padding: 0px;
      }

      .button-distance {
        margin-bottom: 10px !important;
      }
    }
</style>